import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/react';
import { clickAreaClickHandler } from '../click-area-helper';
var clickWrapper = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  height: 100%;\n"])));
export var ClickAreaBlock = function ClickAreaBlock(_ref) {
  var editorView = _ref.editorView,
    editorDisabled = _ref.editorDisabled,
    children = _ref.children;
  var handleMouseDown = React.useCallback(function (event) {
    if (!editorView) {
      return;
    }
    if (!editorDisabled) {
      clickAreaClickHandler(editorView, event);
    }
  }, [editorView, editorDisabled]);
  return jsx("div", {
    "data-testid": "click-wrapper",
    css: clickWrapper,
    onMouseDown: handleMouseDown
  }, children);
};
export default ClickAreaBlock;